import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    timeSign,
    taxAgentName,
    taxAgentId,
    taxCalculationPeriodEnd,
    hightIncomeBusiness,
    percent,
    contract,
    contractDate,
  },
} = checkout;

const validation = Yup.object().shape({
  [taxAgentName.name]: Yup.string().notRequired(taxAgentName.errorMsg),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [hightIncomeBusiness.name]: Yup.string().required(hightIncomeBusiness.errorMsg),
  [contract.name]: Yup.string().notRequired(contract.errorMsg),

  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxCalculationPeriodEnd.name]: Yup.number().required(taxCalculationPeriodEnd.errorMsg),
  [contractDate.name]: Yup.number().notRequired(contractDate.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [percent.name]: Yup.number().required(percent.errorMsg),

  [taxAgentId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgentId.invalidMsg)
    .notRequired(taxAgentId.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
});

export default validation;
